"use client"

import clsx from "clsx"
import { useState } from "react"
import { useCountryCode } from "src/components/(checkout)/country/state"
import { CountrySelectModal } from "src/components/common/CountrySelectModal"
import { useCountries } from "src/components/common/useCountries"
import { ArrowRightIcon, Spinner } from "src/components/icons"
import { CountryFlag } from "src/components/layout/header/CountryFlag"
import { useEventCallback } from "src/hooks/useEventCallback"
import { localizeText } from "src/localization/utils"
import { StorefrontCountry } from "src/types/storefront"

export type CountrySelectToggleButtonProps = {
  className?: string
}

export const CountrySelectToggleButton = ({ className }: CountrySelectToggleButtonProps) => {
  const { data: countries, loading } = useCountries()
  const countryCode = useCountryCode()
  const [isOpen, setOpen] = useState(false)
  const open = useEventCallback(() => setOpen(true))
  const close = useEventCallback(() => setOpen(false))

  const T = localizeText(text)
  const activeCountry = countries.find((country) => country.code === countryCode)

  return (
    <>
      <button
        type="button"
        onClick={open}
        className={clsx(className, "flex items-center gap-2 opacity-75 hover:opacity-100")}
      >
        {T.format_shipping(activeCountry)}
        {loading && <Spinner className="h-4 w-4" />}
        <ArrowRightIcon />
      </button>

      {isOpen && <CountrySelectModal close={close} countryCode={countryCode} countries={countries} />}
    </>
  )
}

const de = {
  format_shipping: (country: StorefrontCountry | undefined) =>
    country ? (
      <>
        Versand nach
        <CountryFlag country={country} />
        {country.name}
      </>
    ) : (
      <>Versand</>
    ),
}

const en: typeof de = {
  format_shipping: (country: StorefrontCountry | undefined) =>
    country ? (
      <>
        Shipping to
        <CountryFlag country={country} />
        {country.name}
      </>
    ) : (
      <>Shipping</>
    ),
}

const text = { de, en }
